let React   = require('react');
let Reflux  = require('reflux');
let mui     = require('material-ui');
let Actions = require('../actions');

let TextField    = mui.TextField;
let RaisedButton = mui.RaisedButton;

let LoginForm = React.createClass({
  mixins: [React.addons.PureRenderMixin],

  getInitialState () {
    return {
      jid:      '',
      password: '',
      error:    '',
    };
  },

  handleKeyUp (e) {
    if (e.keyCode === 13) {
      this._submit();
    }
  },

  handleClick () {
    this._submit();
  },

  _submit () {
    if (this.state.jid.length === 0) {
      this.setState({ error: 'Name ist falsch!' });
      return;
    }
    this.state.jid = this.state.jid+"@flowx.im";
    Actions.login(this.state.jid, this.state.password);
  },

  handleJidChange (e) {
    this.setState({
      jid:   e.target.value,
      error: '',
    });
  },

  handlePasswordChange (e) {
    this.setState({
      password: e.target.value,
    });
  },

  render () {
    return (
      <div className="login-form" onKeyUp={this.handleKeyUp}>

        <div className="input-group">
          <TextField fullWidth={true} hintText="Name" value={this.state.jid} onChange={this.handleJidChange} errorText={this.state.error} />
        </div>

        <div className="input-group">
          <TextField fullWidth={true} hintText="Passwort" type="password" value={this.state.password} onChange={this.handlePasswordChange} />
        </div>

        <div className="form-actions">
          <RaisedButton color="#0B70B5" label="Anmelden" primary={true} onClick={this.handleClick} />
        </div>
      </div>
    );
  },

});

module.exports = LoginForm;



/** WEBPACK FOOTER **
 ** ./src/app/components/login_form.jsx
 **/